export default {
    GROUP: 'idGroup',
    ACTIVITIES: 'idActivity',
    BONO: 'idBono',
} as const;
